// extracted by mini-css-extract-plugin
export default {"container":"JqgraeoRgZG38TfJl8Q4","label":"h60Nv66Ttw_iPDiJEYES","text":"MKCcF0SOC83j5fb5upQV","termsContainer":"C_8kapLhnVOIsADcGyV0","pulse":"LaEyAaEu0aHfFVMijKMz"};